var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMrskgreet1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 461.12 407.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d6d6d6;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        stroke-width: 3px;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #e6e6e6;\n        stroke: #e6e6e6;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 3px;\n      }\n\n      .cls-4 {\n        fill: #848484;\n        stroke: #848484;\n      }\n\n      .cls-5 {\n        fill: #b5b5b6;\n        stroke: #b5b5b6;\n      }\n\n      .cls-6 {\n        fill: #9c9c9c;\n        stroke: #9c9c9c;\n      }\n\n      .cls-7 {\n        fill: #9b9b9b;\n        stroke: #9b9b9b;\n      }\n\n      .cls-8 {\n        fill: #5f5f5f;\n      }\n\n      .cls-8, .cls-9 {\n        stroke: #5e5f5f;\n      }\n\n      .cls-9 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colour_Mirror",
    "data-name": "Colour Mirror"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "255.25 321.02 255.25 321.02 255.25 321.02 302.51 259.68 309.84 187.35 187.4 189.68 205.29 250.55 255.25 321.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M328.63,247.08l47.92,24.19s-5.37,25.98-5.37,29.71,9.7,24.34,9.7,24.34l-2.99,10.15,2.09,11.79,9.41,7.61v12.39l4.03,11.05v17.62l-161.76,9.27,23.59-84.19,36.13-53.72,1.96-37.49,11.85-6.91,23.78,17.25-.34,6.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.73,275.04s12.97-2.6,16.85-2.6c0,0,2.53,4.98.45,13.58,0,0,11.67-19.51,11.67-21.6s-20.75,0-20.75,0l-8.21,10.62h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M181.87,247.08l-47.92,24.19s5.37,25.98,5.37,29.71-9.7,24.34-9.7,24.34l2.99,10.15-2.09,11.79-9.41,7.61v12.39l-4.03,11.05,5.4,17.93,156.36,8.96-23.59-84.19-36.13-53.72-1.96-37.49-11.85-6.91-23.78,17.25.34,6.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.78,275.04s-12.97-2.6-16.85-2.6c0,0-2.53,4.98-.45,13.58,0,0-11.67-19.51-11.67-21.6s20.75,0,20.75,0l8.21,10.62h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Colour_Normal",
    "data-name": "Colour Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.32,241.05s-3.13,14.38-5.39,15.67c-2.26,1.29-3.37,1.66-3.37,1.66,0,0-9.35-4.07-10.23-7.28l.59,11.55,20.78,1.69s.45-8.72,0-12.78-2.39-10.51-2.39-10.51h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M258,394.08s-40.85-65.77-49.26-85.57c0,0,7.88,39.86,13.97,56.19s14.18,41.59,14.18,41.59l21.12-12.21h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M214.02,395.4s-20.89-56.19-24.35-78.23c0,0-1.49,45.55,10.15,78.23h14.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M158.44,336.07s2.16,6.72,2.64,12.9c.51,6.48-2.12,4.77-2.12,4.77,0,0-15.36-10.37-20.35-15.96,0,0,9.18,15.9,8.98,19.62s-20.41-5.32-22.94-5.65c0,0-9.02,9.65-8.35,18.22,0,0-.5,7.97-1.29,15.52s25.45,19.73,25.45,19.73l29.73-1.43-1.13-44.87-10.61-22.83v-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M288.17,395.4s34.07-66.38,38.97-86.89c4.01-16.8-3.07,63.59-16.26,89.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M357.21,328.84c6.75-27,7.98-44.8,4.6-58,0,0-4.3,27-20.25,60.76s-11.66,70.61-11.66,70.61l66.59-11.54-6.44-24.39-.92-14.08-5.52-4.95s-7.01,8.37-15.76,12.71c-2.01,1-4-1.39-2.65-3.19,5.11-6.82,12.99-18.25,13.19-24.25l3.99-8.29-8.59-15.73s5.22,9.29-.92,15.73c-3.55,3.73-9.26,9.51-13.44,13.72-1.55,1.56-4.18.14-3.72-2.02l1.51-7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M292.17,242.72s3.32-4.44,4.68-1.67-.68,10.02-.68,10.02l4-13.74-3.17-5.91-3.77,3.95-1.06,7.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M296.17,253.79s22.12-8.45,23.02-5.44-25.25,38.67-25.25,38.67c0,0,35.51-27.35,39.14-27.65s21.44-.15,21.44-.15l-26.26-12.68,1.12-6.49-3.69-.62-29.52,14.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M287.55,188.52l-28.99,20.14-15.81-1.58-12.19-8.65,4.9,21.05s9.43,5.17,11.77,13.17,5.33,15.88,10.33,21.78c0,0,9.33-18.77,14.67-30.78h2.67l-7.67,39h21.17l3.33-31.23-4.18-42.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror",
    "data-name": "Lines Mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M280.8,198.42s-13.68,53.49-14.34,66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M259.12,274.6s5.34-8.17,7.34-9.51,13.18,1,21.35-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M255.25,319.98s28.75-42.93,32.55-50.97,3.57-34.68,3.57-34.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M253.76,321.88s-49.49-44.84-56.47-55.41-13.32-22.42-17.55-21.78c0,0-.87-2.73,0-3.85s3.86-2.61,3.86-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M329.91,246.07s45.56,22.54,48.38,22.94-14.5,47.84-18.07,53.87-19.58,28.62-20.9,46.5-.94,28.8-.94,28.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M378.15,272.9s-4.18,24.19-4.18,31.53,7.53,16.38,8.28,19.2-1.32,8.53-2.07,10.6.25,9.46,1.63,11.16,7.54,6.17,8.48,8.43.81,9.15.81,11.97,3.83,9.41,3.89,11.67,0,10.73,0,10.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.71,198.42s13.68,53.49,14.34,66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M251.39,274.6s-5.34-8.17-7.34-9.51-13.18,1-21.35-1.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M219.13,234.33s-.23,26.64,3.57,34.68,32.55,50.97,32.55,50.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M256.74,321.88s49.49-44.84,56.47-55.41,13.32-22.42,17.55-21.78c0,0,.87-2.73,0-3.85s-3.86-2.61-3.86-2.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M180.59,246.07s-45.56,22.54-48.38,22.94,14.5,47.84,18.07,53.87,19.58,28.62,20.9,46.5.94,28.8.94,28.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M132.36,272.9s4.18,24.19,4.18,31.53-7.53,16.38-8.28,19.2,1.32,8.53,2.07,10.6-.25,9.46-1.63,11.16-7.54,6.17-8.48,8.43-4.84,1.79-4.84,4.61-.83,15.07-1.3,17.28c-2.6,12.27,10.58,22.46,10.58,22.46"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_Normal",
    "data-name": "Lines Normal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M252.15,319.98s13.67,15,14.05,17.93-1.91,15.41-1.91,23.43,3.31,32.73,3.31,32.73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 245.57,
    y: 72.61,
    width: 44.2,
    height: 111.44,
    transform: "translate(80.56 358.78) rotate(-76.54)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "241.59 118.3 238.67 120.73 239.82 123.85 244.22 124.1 245.39 120.61 241.59 118.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "292.6 130.36 289.68 132.78 290.83 135.9 295.23 136.16 296.4 132.66 292.6 130.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M327.46,134.49l-46.53-63.39h0l-70.19,35.46-18.71,44.43,28.43,30.42,15.52,23.75,23.75,4.33,19.72-8.33,44.58-18.58,3.43-48.09h0ZM253.59,129.29l-13.32,2.66-15.74-9.61-.35-9.62,13.96-3.53,11.83,6.27,6.44,10.8-2.81,3.03h0ZM308.04,142.32l-18.39,1.44-10.67-8.4-1.13-3.98,10.63-6.72,13.38-.23,10.85,9.47-4.66,8.42h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "353.67 244.86 337.06 250.26 319.15 242.22 310.65 253.6 278.14 260.81 287.41 249.51 285.07 237.16 264.64 244.64 270.31 234.13 271.18 217.31 279.45 201.17 287.41 194.95 303.56 172.88 333.29 137.76 336.2 122.01 342.67 139.81 341.67 151.38 355.04 174.91 336.02 196.53 333.53 231.1 346.36 244.05 353.67 244.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M275.7,134.58c.75-1.29,2.14-3.19,2.14-3.19l1.13,3.98,10.67,8.4,18.39-1.44,4.66-8.42-10.85-9.47-13.84-.74-10.17,7.69,10.03-16.2,22.84,4.14s9.38,20.92,5.45,24.93c-3.92,4-27.6,5.82-30.06,5.23s-11.15-13.62-10.41-14.91h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.42,165.17c1.6.38,5.95-.52,7.15-.23s1.57,3.6.62,4.28-5.99,1.24-8.91.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "132.59 190.26 147.81 215.8 174.09 208.43 179.32 226.54 204.84 243.34 199.56 228.58 211.18 213.13 212.21 227.79 227.78 240.05 225.26 219.36 228.68 203.41 223.38 187.74 219.09 178.6 214.69 151.61 204.08 106.84 208.61 91.48 194.78 104.41 190.44 115.18 167.87 130.11 175.04 158 161.61 189.95 144.3 195.69 132.59 190.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M256.87,130.07c-.08-1.49-.46-3.82-.46-3.82l-2.81,3.03-13.32,2.66-15.74-9.61-.35-9.62,13.96-3.53,12.68,5.6,5.59,11.47-1.61-18.99-22.24-6.65s-17.83,14.41-16.15,19.76c1.68,5.35,21.97,17.69,24.43,18.28s16.11-7.09,16.03-8.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M258.42,165.17c-1.6-.38-5.07-3.16-6.27-3.45s-3.03,2.5-2.49,3.54,4.78,3.82,7.62,4.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.67,208.64c5.07-3.32,15.71-10.31,17.29-11.48,2.09-1.56,3.9-9.86,3.93-10.88s9.86-17.36,11.64-21.22c1.78-3.86,20.67-17.61,20.67-17.61,0,0,13.02-4.38,1.48-19.12-5.67-7.24-23.64-3.72-23.46-6.48.36-5.79-10.81-23.45-10.81-23.45-6.58,1.85-18.49,15.8-18.49,15.8l-22.71-20.81,29.58-23.21,37.73,9.03,22.67,63.03-26.39,47.71-36.48,21.04-6.64-2.35h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M224.75,128.74s-2.96,2.61-3.04,4.59,9.17,9.72,10.5,12.89-1.37,22.41-1.37,22.41c0,0-1.78-14.69-5.89-16.07s-8.35,8.04-8.35,8.04l-6.98-29.01,4.72-13.84,10.42,10.99h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M279.8,126.03s-8.4,7.41-9.44,10.47-3.17,27-3.86,29.01c-.26.75-7.85,3.52-6.47,4.15,2.31,1.05,13.27-1.32,13.27-1.32,0,0,.66-13.84,1.84-23.75,1.09-9.11,4.65-18.56,4.65-18.56h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M173.14,181.23c-1.91,8.71-11.85,12.23-14.72,13.7s-9.02,4.15-9.02,4.15c0,0,6.61,3.92,8.48,4.37s16.85-5.32,16.85-5.32c0,0-.56,5.62-.13,6.26s8.3,6.84,8.3,6.84c0,0,2.92-8.11,3.37-9.98s-13.14-20.02-13.14-20.02h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M169.66,138.47c-6.31-10.36.59-9.21.59-9.21l18.46-13.26,2.18-3.87s-1.91,11-2.96,12.36-6.98,5.88-6.98,5.88c0,0-2.07,20.48-2.75,23.91,0,0-3.52-7.6-8.53-15.83v.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M327.92,200.89s16.04-11.91,17.82-19.35c0,0-3.95-12.26-4.14-15.59s-6.66-4.38-6.66-4.38c0,0-3.9,4.64-4.12,5.57s7.44,11.95,5.38,15.89-8.28,17.86-8.28,17.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M335.25,231.52s-7.26-6-7.1-10.06c0,0-.3,16.33,1.82,19.79s10.09,9.3,10.09,9.3l13.93-5.52-7.82-.23-10.93-13.28h.01Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 275.86,
    y1: 136.86,
    x2: 283.56,
    y2: 148.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M313.26,135.6l-11.53-10.91s-12.3-.69-14.94.5-8.96,6.19-8.96,6.19c0,0,4.47-8.84,6.9-9.91,2.43-1.07,13.19-1.8,13.19-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M306.89,142.03s-15.03,1.84-16.36,1.42-10.33-7.81-10.33-7.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M297.82,135.16s-1.67-4.62-2.57-4.97-5.32-.02-5.84.54-1.14,3.73-.95,4.55,4.11,3.5,4.92,3.51,4.19-2.79,4.44-3.63h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.88,168.02s-.12-.62-2.15-.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M317.43,119.92s-12.08-4.4-16.36-4.94-17.22,1.03-18.69.38,2.19-3.52,2.19-3.52c0,0,14.64,1.32,16.72,1.82s16.14,6.26,16.14,6.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M248.07,208.43s10.48,2.49,12.25,2.56,24.57-13.42,26.26-15.52,10.21-15.03,15.93-21.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M277.37,202.84s-7.08,12.74-7.66,17.97c-.58,5.23-.31,12.51-1.27,15.13s-7.95,12.19-7.95,12.19c0,0,18.17-4.38,23.07-8.74,0,0,2.08,9.56,1.73,10.99s-8.11,11.48-10.44,12.77c0,0,34.91-7.75,37.19-9.56s7.64-10.17,7.64-10.17c0,0,17.07,7.19,18.98,7.65s26.28-8.81,26.28-8.81c0,0-14.67,1.69-17.05,1.12s-12.51-11.55-12.48-13.06,2.17-28.68,2.74-31.06,18.43-21.6,18.76-24.38-13.09-21.74-13.21-24.05.33-20.99-6.17-29.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 255.7,
    y1: 132.04,
    x2: 243.72,
    y2: 138.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M222.91,113.98l15.21-4.51s11.28,4.96,13.1,7.21,5.18,9.57,5.18,9.57c0,0,.02-9.9-1.67-11.96s-10.94-7.58-10.94-7.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M225.69,122.59s12.56,8.44,13.94,8.67,12.75-2.29,12.75-2.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M236.88,120.57s3.58-3.37,4.54-3.26,4.76,2.39,4.97,3.13-.68,3.84-1.22,4.49-5.25,1.26-5.98.9-2.48-4.39-2.31-5.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M252.27,165.24s.38-.5,2.07.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M226.29,98.1s12.76,1.55,16.83,3,14.89,8.71,16.49,8.81-.36-4.13-.36-4.13c0,0-13.65-5.45-15.74-5.95s-17.23-1.73-17.23-1.73h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M248.07,208.43s-10.47-2.52-12.08-3.26-15.83-23.09-16.39-25.73-2.3-18.02-4.68-25.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M224.47,190.17s7,11.26,5.15,16.19-3.82,12.28-4.15,15.05,4.15,20.42,4.15,20.42c0,0-19.12-3.12-19.09-23.7,0,0-7.84,9.31-8.18,10.74s3.84,16.38,5.33,18.58c0,0-28.64-18.03-29.86-20.67s-4.96-15.8-4.96-15.8c0,0-23.14,5.27-25.04,4.81s-19.25-30.12-19.25-30.12c0,0,12.31,8.15,14.69,8.72s16.38-4.64,17.04-5.99,11.05-26.55,11.62-28.93-6.65-27.6-5.69-30.23,21.51-13.46,22.66-15.46,9.21-18.86,18.9-23.59"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hair_Top_Colour",
    "data-name": "Hair Top Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M208.92,77.74s3.09,10.45-2.67,21.89-8.01,18.65-8.01,18.65l4.66,24.97s-5.81,11.54-16.72,16.86c0,0,4.46,29.75,6.33,35.02s11.38-3.09,11.38-3.09l-6.91-.56s-3.72-16.51-1.85-24.3,20.83-18.11,20.83-18.11l-6.36-17.49,11.06-20.05,10.01-9.81,1.03,8.39,7.44-18.25,16.09-7.45-4.38,8.22.24,23.58,5.78-18.65,17.15-13.94,4.79,6.62,5.62-9.77s3.76,10.45,4.47,21.88c.71,11.44-.04,18.46-.04,18.46l5.63-16.49.8-11.51,9.29,20.54.6,15.8,4.46-12.76,8.64,29.93-2.1,11.39-13.91,11.7,11.35,23.85s-10.27,21.33-10.85,22.44-10.32-2.36-10.32-2.36l9.15,7.25s17.58-10.66,24.03-26.49c0,0-10.4-13.44-8.7-20.55s36.55-48.66,36.55-48.66c0,0-12.19-10.62-12.83-19.06s.73-26.59.73-26.59l-16.18-16.08,19.98,4.78,6.2,14.63-3.37-21.87s-29.02-8.89-32.2-13.25c-3.18-4.36-14.29-14.84-14.29-14.84l-8.48,15.81-20.31-26.3s-22.2,13.62-28.86,12.03-26.44-11.81-32.21-23.67,8.83,30.44,12.03,32.77,31.08,2.43,34.62-2.67c3.54-5.1,15.68-6.73,15.68-6.73l11.31,16.64-18.71-6.83-30.52,8.66-32.95,12.77-13.68,12.69-2.27,15.39,11.01-17.21,10.73,1.79h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.6,71.63s21.19-11.74,24.53-15.8,20.2-6.98,20.2-6.98c0,0-1,2.78,1.33,4.39,2.33,1.61,20.95,2.12,23.77,3.06,0,0-15.54,7.57-18.67,11.81-3.14,4.24-13.74,11.29-13.74,11.29,0,0,4.14-9.64,3.41-11s-33.89,39.54-33.89,39.54l5.31-19.98s9.19-8.17,10.35-12.76c0,0-10.89-7.99-22.59-3.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.21,28.37s9.78,16.1,20.29,14.63,13.79-6.47,13.79-6.47c0,0-20.54,5.24-34.07-8.16,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.48,94.35s10.4-15,12.28-18.02,13.33-8.64,13.33-8.64l-8.32,12.41-17.29,14.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M296.17,78.17l.16-7.74s10.64,11.4,17.74,9.7,4.7-19.63,4.7-19.63c0,0,9.39,7.52,10.94,11.23s4.69,8.32,3.97,11.36-.47,10.56,1.09,14.79c0,0-4.97,21.83-5.76,27.29,0,0-.92-19.25-7.43-26.98,0,0-8.71-3.11-12.76-13.73,0,0-2.27,12.06-5.55,12.3s-7.99-5.13-7.1-18.61c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M302.25,31.81s4.45,14.92,6.81,16.58,7.75,5.13,13.43,2.06c0,0-4.89-2.07-6.24-3.16s-14-15.48-14-15.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M314.87,157.42s9.94.87,16.4-6.34c0,0-15.12,15.91-13.81,22.34s6.37,16.42,4.42,19-16.15-7.49-19.19-22.73c0,0,10.32-7.55,12.18-12.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M197.7,150.83s-4.95,12.04,8.55,4.38c0,0-4.55,2.01-8.63,5.05s-2.41,14-5.32,13.3-6.95-14.05-6.95-14.05l12.35-8.68h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M265.17,73.37c-2.86,5.69-14.59,15.51-15.6,19.76-1.02,4.26.19,27.92.19,27.92,1.31-7.06,7.25-18.26,8.25-20.4s14.95-15.42,16.46-14.93,4.36,8.42,4.36,8.42c0,0,4.22-11.36,5.55-11.17s4.01,29.71,3.19,35.76-2.92,14.29-2.92,14.29c0,0,9.87-23.49,10.38-25.62s.18-29.45.18-29.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M249.69,67.04s-17.64,25.38-18.02,30.56-.1,22.71-.1,22.71c0,0,5.17-22.12,8.61-26.05s16.92-10.82,16.92-10.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M296.16,97.41s8.01,14.04,8.12,21.44-1.01,19.38-1.01,19.38c0,0,7.39-21.48,8.13-24.55s-1.75-21.92-.37-27.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M327.24,63.69c1.96,1.32,17.5,5.18,17.5,5.18,1.08,7.36,12.3,28.11,12.3,28.11-4.37-7.25-7.49-36.9-7.49-36.9-8.21-.69-25.72-10.56-29.83-12.39s-17.55-17.4-17.55-17.4c-3.66,2.82-9.95,16.07-9.95,16.07,0,0-15.25-23.44-19.19-26.1,0,0-16.18,13.16-32.64,11.37-16.46-1.79-33.16-30.13-33.16-30.13,0,0,7.84,34.23,14.54,42.13s31.23,1.46,33.87-.2c2.64-1.66,12.67-8.28,16.47-7.37s11.1,13.43,11.1,13.43c0,0-11.83-7.14-15.16-7.94s-25.77,4.93-39.21,12.45c-13.44,7.52-25.48,9.12-25.48,9.12,0,0-12.71,11.85-16.37,14.55,0,0-2.88,16.2-2.69,24.41,0,0,9.8-22.42,15.5-23.49s33.08-1.24,39.53-7.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M231.29,102.78s-17.78,18.82-19.71,25.97c-1.93,7.16,7.67,17.07,6.93,20.16s-18.78,11.18-21.49,17.06-1.13,20.19,1.11,23.55,14.78-.82,14.78-.82c0,0-13.88,8.87-18.91,8.97s-10.31-35.12-9.94-38.51c0,0,16.49-8.89,16.79-15.57s-4.4-24.34-3.46-27.38,12.83-15.43,11.91-36.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M310.03,120.59s8.07,26.03,6.56,33.29c-1.52,7.25-14.57,11.75-15.3,14.84s11.69,18.47,11.44,24.94c-.24,6.47-8.13,18.51-11.65,20.5s-12.81-7.42-12.81-7.42c0,0,8.36,14.19,12.8,16.56s25.09-26.64,26.29-29.84c0,0-10.68-15.4-7.92-21.48,2.76-6.09,15.48-22.85,15.48-22.85l20.42-25.49s-8.35-4.25-11.02-13.27c-2.67-9.01-.58-30.8-1.36-31.7s-26.31-25.32-29.09-26.13-13.85-2.04-13.85-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M233.21,169.92s8.89,16.43,15.41,19.5,23.37.8,30.08-5.58c0,0-29.17-6.71-32.28-8.31s-13.21-5.62-13.21-5.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M242.52,172.76s-2.78,3.45-2.78,7.59-6.53-11.72-6.53-11.72l9.31,4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M268.36,181.23s-.04,8.66-1.91,10.18l12.25-7.56-10.34-2.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M228.68,165.9s23.11,9.73,28.07,11.53c4.96,1.8,19.92,5.13,25.05,4.99,0,0-9.34,7.05-15.34,8.99s-20.33,3.72-28.21-11.11c-5.78-10.89-9.57-14.39-9.57-14.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M232.26,170.36s8.35,7.52,10.6,8.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M263.88,186.82s8.63.73,13.07-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hands_COlour",
    "data-name": "Hands COlour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.17,265.13c-5.53-21.62-15.27-40.65-15.27-40.65l-1.73-29.68-18.11-28.82-21.24-9.39,1.43,11.81,12.21,7.81,2.73,18.14-1.82,2.9-10.78-11.95-29.88-7.37-32.05,6.93-15.18,21.82s13.7.08,18.52-11.75l14-2.6-9.85,7.52-8.1,28.82s13.71-3.54,14.12-16.22l2.64-2.19s2.09,10.48-1.27,16.93l3.91,3.82,5.37,13.03,18.15,9.31-.75-5.97-8.27-6.06-1.73-8.64,9.81-2.73s20.55,2.61,23.34,5.47l4.91,6.34-.96,8.76,8.81,10.84s6.07,11.9,8.74,19.97,13.11,41.84,13.11,41.84c0,0,2.47,31.48-3.33,40.08l32.03,29.41s15.25-8.77,15.85-20.86c.6-12.09,2.19-33.93,2.19-33.93,0,0-26.03-51.14-31.56-72.76v.02h0ZM41.46,223.81l1.91-9.97,16.51,4.96-18.42,5.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.95,237.46s11,27.65,15.1,38.14c.36.93.67,1.72.91,2.35,2.99,7.74-12.98-41.44-12.98-41.44l-3.04.95h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M75.94,158.54s14.54,10.12,17.67,11.19l15.03,29.16s6.19,27.97,3.6,30.11c-2.58,2.14-3.97,4.22-3.97,4.22,0,0,4.54-2.85,5.93,1.59s34.79,102.8,35.32,107.18-8.18,47.6-8.18,47.6l3.35,3.08,13.87-13.87,1.53-41.83s-25.01-52.49-35.72-86.68c-10.71-34.19-8.75-30.57-8.75-30.57l-.21-21.76-19.35-31.98-20.13-7.43h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M58.38,219.58s-2.64,9.22-5.12,10-5.42,4.48-5.42,4.48l3.37,7.81,7.56,9.75-17.93-7.55-2.76-8.81s2.89-2.42.58-9.8c0,0,.27-15.59,1.16-16.14s-6.99.97-6.99.97l12.74-9.63,17.82,7.49-2.78,7.74-18.43-2.41-1.77,12.51,17.97-6.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30.98,196.06s7.97-7.94,19.63-3.48c7.42,2.83,18.37,7.81,18.37,7.81l2.02-3.4-23.38-6.14-16.64,5.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M55.81,179.16s19.61,7.35,20.21,8.46,12.28,12.14,12.28,12.14l1.08-2.51-12.13-12.28-21.44-5.81h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Hands"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M34.75,231.73l5.55,13.64c6.22-.72,19.52,8.98,19.54,8.37.32-8.71-7.24-10.3-8.56-11.5-1.5-1.37-3.05-9.53-3.05-9.53l10.5-2.92s20.55,3.77,25.44,8.52,1.48,13.31,1.48,13.31c12.07,8.68,17.71,30.96,26.47,58.93s.09,54.28.09,54.28c5.5.5,32.79,29.35,32.79,29.35,6.23-2.84,15.16-14.67,15.16-14.67l2.13-43.02c-14.65-21.32-43.75-106.83-44.98-109.78s-1.92-30.32-1.92-30.32c-10.64-13.64-18.55-31.17-18.55-31.17-4.37-1.36-22.59-10.2-22.59-10.2,0,0-.33,11.66,2.19,14.43s11.99,6.45,11.99,6.45c0,0,2.06,12.64,2.94,15.45.33,1.06.14,2.19-.22,3.17-.6,1.62-1.68,2.88-1.68,2.88,0,0-10.68-11.51-11.29-13.45s-17.65-1.69-29.3-7.06c0,0-21.14,8.28-32.01,7.65,0,0-13.21,21.46-15.37,22.14,0,0,10.63,4.5,18.4-11.7l26.89-5.81,23.98,7.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M36.14,192.6l-11.72,6.45s-9.39,30.09-10.45,31.41c0,0,16.71-3.9,15.7-18.82,0,0,12-11.28,14.24-11.98s20.79,7.88,20.79,7.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M31.53,209.91c3.73,7.29-.28,18.24-.28,18.24,5.68,2.47,13.92,13.63,13.92,13.63,0,0,2.06-1.79.73-7.59s-5.25-9.97-5.16-10.74,1.17-8.78,2.07-9.06,18.19,2.72,18.19,2.72c0,0,.08,1.88-2.5,2.43s-16.43,5.15-16.43,5.15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrskgreet1);
export default __webpack_public_path__ + "static/media/mrsk greet1.edca1c310c11d144d9b9ded5d59683a3.svg";
export { ForwardRef as ReactComponent };